import { capitalize } from '@material-ui/core'
import moment, { Moment } from 'moment'
import { Sex } from 'utilities'
import { AddressDTO } from './Viewer'

export interface OrganizationDTO {
  id: number
  externalId: string
  name: string
  children: OrganizationDTO[]
}

export enum UserRoleName {
  SUPER_ADMIN = 'SUPER_ADMIN',
  DEPARTMENT_MANAGER = 'DEPARTMENT_MANAGER',
  PROJECT_MANAGER = 'PROJECT_MANAGER',
  OPERATOR_USER = 'OPERATOR_USER',
  VIEW_CONTENT_OWNER = 'VIEW_CONTENT_OWNER',
  VIEW_PRODUCT_OWNER = 'VIEW_PRODUCT_OWNER',
  VIEWER_OPERATOR_USER = 'VIEWER_OPERATOR_USER',
  PERSON_EDIT_ONLY = 'PERSON_EDIT_ONLY',
  VIEWER = 'VIEWER'
}

export interface UserRoleDTO {
  id: number
  label: string
  name: UserRoleName
  permissions: any
  priority: number
}

export interface UserDTO {
  addresses: AddressDTO[]
  changePasswordCode: string
  created: string
  createdBy: UserDTO
  currency: string
  dateOfBirth: string
  emailAddress: string
  externalId: string
  firstName: string
  id: number
  imageUrl: string
  language: string
  lastName: string
  marketplaceId: number
  organizations: OrganizationDTO[]
  phoneNumber: string
  roles: UserRoleDTO[]
  sex: Sex
}

export class User {
  readonly addresses: AddressDTO[]
  readonly changePasswordCode: string
  readonly created: Moment
  readonly createdBy: User
  readonly currency: string
  readonly dateOfBirth: Moment
  readonly emailAddress: string
  readonly externalId: string
  readonly firstName: string
  readonly id: number
  readonly imageUrl: string
  readonly language: string
  readonly lastName: string
  readonly marketplaceId: number
  readonly organizations: OrganizationDTO[]
  readonly phoneNumber: string
  readonly roles: UserRoleDTO[]
  readonly sex: Sex

  constructor (user: UserDTO) {
    for (const key in user) {
      if (key === 'created' || key === 'dateOfBirth') {
        this[key] = moment(user[key])
      } else if (key === 'createdBy' && user[key]) {
        this[key] = new User(user[key])
      } else {
        this[key] = user[key]
      }
    }
  }

  get name (): string {
    return `${this.firstName} ${this.lastName}`
  }

  get rolesAsString (): string {
    return (this.roles || [])
      .map(role => capitalize(role.label.toLowerCase()))
      .join(', ')
  }

  get highestPriorityRoleLabel (): string {
    const roles = [...this.roles || []]
    if (!roles.length) return ''
    roles.sort((a, b) => a.priority - b.priority)
    return capitalize(roles[0].label.toLowerCase())
  }
}
